import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Grid } from "@mui/material";
import Fade from '@mui/material/Fade';

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const ListDetailCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
      <Card
        className={classes.card}
        sx={{ boxShadow: 0,}}
        onClick={() => {
          props.press();
        }}
      >
        <CardContent sx={{ p: 0 }}>
        <Box hover sx={{  color: 'primary.main', px: 2, paddingTop: '1rem', cursor: 'pointer' }}>
          {props.title && (
            <Typography
              className={classes.ModuleNum}
              sx={{ lineHeight: 1.2,height: '5em', color:"#5f5600ff" }}
            >
              {props.title}
            </Typography>
          )}
          {props.subheading && (
            <Typography
              className={classes.ModuleName}
              
            >
              {props.subheading}
            </Typography>
          )}
          </Box>
          {props.line1 && (
            <Typography
              className={classes.cardText}
              color="#064b00ff"
              sx={{ borderTop: 1, borderColor: "#D9D9D9", pt: 1 }}
            >
              {props.line1}
            </Typography>
          )}
          {props.line2 && (
            <Typography
              className={classes.cardText}
              color="primary.main"
              sx={{}}
            >
              {props.line2}
            </Typography>
          )}
          {/* {props.bottomText && (
            <Typography
              className={classes.className}
              sx={{ borderColor: "#C4CBE7", border: 1 }}
            >
              {props.bottomText}
            </Typography>
          )} */}
          {/* {props.bottomExtraText && (
            <Typography
              className={classes.className}
              sx={{ }}
            >
              {props.bottomExtraText}
            </Typography>
          )} */}
        </CardContent>
        {/* <CardActions
          sx={{ justifyContent: "space-between", py: 0, pb: 1, mt: 1 }}
        >
          <Grid>
          {props.leftBottomText && (
            <Typography
              sx={{ color: "#DB8829", fontSize: "0.6rem", textAlign: "left" }}
            >
              {props.leftBottomText}
            </Typography>
          )}
          </Grid>
          <Grid>
            <IconButton
              aria-label="Go"
              size="small"
              sx={{
                borderRadius: "50%",
                backgroundColor: "#F5F5F5",
                color: "#DB8829",
                boxShadow: 0,
                mt: props.bottomExtraText ? 1 : 3,
                '@media (min-width: 1636px)': {
                 marginTop: '2rem'
                }, 
               
              }}
            >
              <ArrowForwardIosIcon fontSize="inherit" sx={{fontSize: '1rem',  '@media (min-width: 1636px)': {
                 fontSize: '1.8rem'
                }, }} />
            </IconButton>
          </Grid>
        </CardActions> */}
      </Card>
    </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  card: {
   background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
    width: "11rem",
    height: '9rem',
    shadowColor: "#000",
    boxShadow: "2rem",
    marginLeft: 5,
    marginRight: 5,
    '@media (min-width: 1636px)': {
      width: '16rem',
      height: '20rem'
    }, 
  },
  ModuleNum: {
    fontSize: "1rem",
    textAlign: "center",
    fontWeight: "600",
    wordWrap: 'break-word',
    height: "2.5rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    '@media (min-width: 1636px)': {
      fontSize: "1.4rem",
      height: "4rem",
    }, 
  },
  ModuleName: {
    fontSize: "0.8rem",
    textAlign: "center",
    fontWeight: "500",
    paddingBottom: 10,
    paddingTop: 10,
    '@media (min-width: 1636px)': {
      fontSize: "1.2rem",
      paddingBottom: 15,
    }, 
  },
  cardText: {
    fontSize: "0.8rem",
    textAlign: "center",
    fontWeight: "500",
    '@media (min-width: 1636px)': {
      fontSize: "1.2rem",
    },  
  },
  className: {
    borderRadius: 10,
    textAlign: "center",
    color: "#000000",
    fontSize: "0.7rem",
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    '@media (min-width: 1636px)': {
      fontSize: "1.2rem",
      marginTop: '1.5rem',
    }, 
  },
});

export default ListDetailCard;
